import { ReactComponent as DefaultItemIcon } from '../../../icons/default-item.svg';
import { ReactComponent as CheckIcon } from '../../../icons/success.svg';

import './food-card.scss';

import { hasMacros, MACRO_DEFS } from '../../../utils/macros';

export const FoodCard = ({ item, selected, onSelect, categoryImageUrl }) => (
  <button
    type="button"
    className={`food-card${selected ? ' selected' : ''}`}
    aria-pressed={selected}
    title={selected ? 'Selected, click to remove' : undefined}
    onClick={() => onSelect(item)}
  >
    {selected && (
      <div className="food-card__tick">
        <CheckIcon width={12} height={12} />
      </div>
    )}
    <div className="food-card__img-wrap">
      {item.imageUrl || categoryImageUrl ? (
        <img src={item.imageUrl ?? categoryImageUrl} alt="" />
      ) : (
        <DefaultItemIcon className="food-card__default-icon" />
      )}
    </div>
    <div className="food-card__name">{item.name}</div>
    {hasMacros(item) ? (
      <div className="food-card__macros">
        {MACRO_DEFS.map(({ key, label, color }) =>
          item[key] != null ? (
            <span
              key={key}
              className="food-card__macro"
              style={{ color, background: `color-mix(in srgb, ${color} 16%, transparent)` }}
            >
              {item[key]}
              {label}
            </span>
          ) : null
        )}
      </div>
    ) : (
      <span className="food-card__no-nutrition">No nutritional info provided</span>
    )}
    {item.price != null && (
      <div className="food-card__badge">R{(item.price * 100).toFixed(0)} / 100g</div>
    )}
  </button>
);
